(function () {
  var MAX_EVENTS_PER_PAGE = 25;
  var MAX_TRACK_EVENTS_PER_PAGE = 40;
  var MAX_PER_SIGNATURE = 2;
  var MAX_PARAM_LENGTH = 100;
  var GTAG_WAIT_MS = 15000;

  var sentCount = 0;
  var trackCount = 0;
  var signatureCounts = {};
  var pending = [];
  var gtagReady = false;
  var gaveUp = false;

  var IGNORED_MESSAGES = [
    "Script error.",
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    "The play() request was interrupted",
    "AbortError",
  ];

  var VENDOR_SOURCE = /klaviyo|shopmy\.us|automizely|retention\.com|googletagmanager|google-analytics|doubleclick|connect\.facebook|hotjar|attentivemobile|okendo|stay\.ai|gorgias|amazonaws\.com|tiktok|pinterest|snapchat|bing\.com|criteo|justuno|yotpo/i;

  function truncate(value) {
    if (value === undefined || value === null) return "";
    return String(value).slice(0, MAX_PARAM_LENGTH);
  }

  function cleanPath() {
    try {
      return truncate(window.location.pathname);
    } catch (e) {
      return "";
    }
  }

  function context() {
    var ctx = window.GhiaCtx || {};
    return {
      page_path: cleanPath(),
      page_template: truncate(ctx.template),
      product_handle: truncate(ctx.handle),
    };
  }

  function isVendor(source) {
    if (!source) return false;
    return VENDOR_SOURCE.test(String(source));
  }

  function isIgnored(message) {
    var text = String(message || "");
    for (var i = 0; i < IGNORED_MESSAGES.length; i++) {
      if (text.indexOf(IGNORED_MESSAGES[i]) !== -1) return true;
    }
    return false;
  }

  function flush() {
    if (!gtagReady || !window.gtag) return;
    while (pending.length) {
      var item = pending.shift();
      try {
        window.gtag("event", item.name, item.params);
      } catch (e) {
        return;
      }
    }
  }

  function waitForGtag() {
    var started = Date.now();
    var timer = setInterval(function () {
      if (typeof window.gtag === "function") {
        gtagReady = true;
        clearInterval(timer);
        flush();
        return;
      }
      if (Date.now() - started > GTAG_WAIT_MS) {
        gaveUp = true;
        pending.length = 0;
        clearInterval(timer);
      }
    }, 500);
  }

  function dispatch(name, params) {
    var payload = context();
    for (var key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        payload[key] = truncate(params[key]);
      }
    }

    pending.push({ name: name, params: payload });
    flush();
  }

  function send(name, params) {
    if (gaveUp) return;
    if (sentCount >= MAX_EVENTS_PER_PAGE) return;

    var signature = name + "|" + (params.error_message || "") + "|" + (params.error_source || "");
    signatureCounts[signature] = (signatureCounts[signature] || 0) + 1;
    if (signatureCounts[signature] > MAX_PER_SIGNATURE) return;

    sentCount++;
    dispatch(name, params);
  }

  function track(name, params) {
    if (gaveUp) return;
    if (trackCount >= MAX_TRACK_EVENTS_PER_PAGE) return;

    trackCount++;
    dispatch(name, params || {});
  }

  function reportError(event) {
    if (!event) return;

    if (event.target && event.target !== window && event.target.tagName) {
      var url = event.target.src || event.target.href;
      if (isVendor(url)) return;
      send("resource_error", {
        error_message: truncate(event.target.tagName.toLowerCase() + " failed to load"),
        error_source: truncate(url),
      });
      return;
    }

    if (isIgnored(event.message)) return;
    if (isVendor(event.filename)) return;

    send("js_error", {
      error_message: truncate(event.message),
      error_source: truncate(event.filename),
      error_line: truncate((event.lineno || 0) + ":" + (event.colno || 0)),
      error_stack: truncate(event.error && event.error.stack),
    });
  }

  function reportRejection(event) {
    var reason = event && event.reason;
    var message = reason && reason.message ? reason.message : String(reason);
    if (isIgnored(message)) return;

    var stack = reason && reason.stack ? String(reason.stack) : "";
    if (isVendor(stack)) return;

    send("js_error", {
      error_message: truncate("unhandled rejection: " + message),
      error_source: truncate(stack.split("\n")[1] || ""),
      error_stack: truncate(stack),
    });
  }

  window.ghiaReport = function (name, params) {
    send(name, params || {});
  };

  window.ghiaTrack = function (name, params) {
    track(name, params);
  };

  window.addEventListener("error", reportError, true);
  window.addEventListener("unhandledrejection", reportRejection);

  var queued = window.__ghiaErrQ || [];
  for (var i = 0; i < queued.length; i++) {
    if (queued[i][0] === "error") reportError(queued[i][1]);
    else reportRejection(queued[i][1]);
  }
  window.__ghiaErrQ = null;

  var originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === "string" ? input : input && input.url ? input.url : "";
      var isCart = url.indexOf("/cart/") !== -1;

      if (!isCart) return originalFetch.apply(this, args);

      return originalFetch.apply(this, args).then(
        function (response) {
          if (!response.ok) {
            response
              .clone()
              .json()
              .then(function (data) {
                send("cart_error", {
                  error_message: truncate(data && (data.description || data.message)),
                  error_source: truncate(url),
                  http_status: response.status,
                  error_stage: "response",
                });
              })
              .catch(function () {
                send("cart_error", {
                  error_message: "non-ok response",
                  error_source: truncate(url),
                  http_status: response.status,
                  error_stage: "response",
                });
              });
          }
          return response;
        },
        function (error) {
          send("cart_error", {
            error_message: truncate(error && error.message ? error.message : error),
            error_source: truncate(url),
            http_status: 0,
            error_stage: "network",
          });
          throw error;
        }
      );
    };
  }

  waitForGtag();
})();
